// datatable related plugins
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { TEMPLATE_UPLOAD_CAMPAIGN } from "constants/CampaignInvoiceConstant";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_WARNING,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import React, { useEffect, useState } from "react";
import { customFilter, selectFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Badge,
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import {
  getInvoiceCampaignList,
  releaseCampaignsInvoice,
  resetListIssueInvoice,
  resetReleaseCampaignsInvoice,
  resetSetBuStoreHeader,
  resetUploadCampaignsInvoice,
  setColumnVisibleInvoiceCampaignList,
} from "store/actions";
import {
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_SUCCESS,
} from "store/dashboard/actionTypes";
import {
  RELEASE_CAMPAIGNS_INVOICE_FAIL,
  RELEASE_CAMPAIGNS_INVOICE_SUCCESS,
  UPLOAD_CAMPAIGNS_INVOICE_FAIL,
  UPLOAD_CAMPAIGNS_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import {
  downloadReportInvoice,
  executeReport,
  getReportLog,
  resetDownloadReportInvoice,
  resetExecuteReport,
  resetGetReportInvoiceProgress,
  resetReportInvoiceList,
} from "store/summary-invoice-data/actions";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
  EXECUTE_REPORT_FAIL,
  EXECUTE_REPORT_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DetailData from "./DetailData";
import { getCampaignStatus, SELECT_FILTER_TYPE } from "./helper/functionHelper";
import ErrorUploadModal from "./Modal/ErrorUploadModal";
import UploadFileAttack from "./Modal/UploadFileAttack";
const ListData = props => {
  // modalErrorUpload
  const [errorUpload, setErrorUpload] = useState(null);
  const [modalErrorUpload, setModalErrorUpload] = useState(false);
  const toggleErrorUploadModal = () => setModalErrorUpload(!modalErrorUpload);

  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => {
    if (modalDetail) {
      resetDataFunc();
    }
    setModalDetail(!modalDetail);
  };

  // Confirm Release modal
  const [modalConfirmRelease, setModalConfirmRelease] = useState(false);
  const toggleConfirmReleaseModal = () =>
    setModalConfirmRelease(!modalConfirmRelease);
  const [idRelease, setIdRelease] = useState(null);

  const [modalUploadFile, setModalUploadFile] = useState(false);
  const toggleUploadFileModal = () => setModalUploadFile(!modalUploadFile);

  // Button download template
  const [isOpenDownloadTemplate, setIsOpenDownloadTemplate] = useState(false);
  const toggleOpenDownloadTemplate = () =>
    setIsOpenDownloadTemplate(!isOpenDownloadTemplate);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { type, uploadCampaignsInvoiceData, releaseCampaignsInvoiceData } =
    issueInvoice;
  const { loading, listData, totalCount, columnsVisible, params } =
    issueInvoice.invoiceCampaignListData;

  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const {
    type: typeReport,
    fileDownload: fileDownloadReport,
    fileDownloadName: fileDownloadNameReport,
  } = summaryInvoiceData;

  const history = useHistory();

  const { t, i18n } = useTranslation(["issueInvoice"]);

  const [commonStatus, setCommonStatus] = useState(getCampaignStatus(t));

  useEffect(() => {
    setCommonStatus(getCampaignStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (type) {
      case UPLOAD_CAMPAIGNS_INVOICE_SUCCESS: {
        addToast("Upload lô hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        setDataDetail({
          report_id: uploadCampaignsInvoiceData?.data?.report_id,
          id: uploadCampaignsInvoiceData?.data?.id,
        });
        toggleViewDetailModal();
        toggleUploadFileModal();
        resetDataFunc();
        dispatch(resetUploadCampaignsInvoice());
        break;
      }
      case UPLOAD_CAMPAIGNS_INVOICE_FAIL:
        addToast("Upload lô hóa đơn thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetUploadCampaignsInvoice());
        break;
      case RELEASE_CAMPAIGNS_INVOICE_SUCCESS: {
        addToast("Phát hành lô hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        if (modalConfirmRelease) {
          toggleConfirmReleaseModal();
        }
        if (modalDetail) {
          toggleViewDetailModal();
        }
        resetDataFunc();
        dispatch(resetReleaseCampaignsInvoice());
        break;
      }
      case RELEASE_CAMPAIGNS_INVOICE_FAIL:
        addToast("Phát hành lô hóa đơn thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetReleaseCampaignsInvoice());
        break;
    }
  }, [type]);

  useEffect(() => {
    switch (typeReport) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownloadReport !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadReport;
          link.setAttribute("download", fileDownloadNameReport);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      case EXECUTE_REPORT_SUCCESS: {
        if (!modalDetail) {
          addToast("Import lô hóa đơn thành công", {
            appearance: "success",
            autoDismiss: true,
          });
          resetDataFunc();
          dispatch(resetExecuteReport());
        }
        break;
      }
      case EXECUTE_REPORT_FAIL:
        if (!modalDetail) {
          addToast("Import lô hóa đơn thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetExecuteReport());
        }
        break;
    }
  }, [typeReport]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, type: typeDashboard } = Dashboard;

  // Action list chang tenantCode
  const [isCheckChangeStore, setIsCheckChangeStore] = useState(false);
  useEffect(() => {
    if (typeDashboard === SET_BU_STORE_HEADER) {
      setIsCheckChangeStore(true);
    }
    if (typeDashboard === SET_BU_STORE_HEADER_SUCCESS && isCheckChangeStore) {
      params.page = 1;
      dispatch(getInvoiceCampaignList(params));
      dispatch(resetSetBuStoreHeader());
    }
  }, [typeDashboard]);

  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetReportInvoiceList());
      dispatch(resetListIssueInvoice());
      dispatch(resetGetReportInvoiceProgress());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail(row);
      toggleViewDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-send font-size-20 text-success" />,
      text: "Phát hành lô hóa đơn",
      isShow: !modalDetail,
      conditionVisible: {
        can_release: [true],
        is_release: [0],
        auth_status: [AUTH_STATUS_APPROVE],
      },
      onClick: row => {
        openReleaseModal(row.id);
      },
    },
    {
      icon: <i className="fas fa-file-import font-size-20 text-info" />,
      text: "Import lô hóa đơn",
      isShow: !modalDetail,
      conditionVisible: {
        // can_release: [true],
        // is_release: [0],
        ["report.status"]: [AUTH_STATUS_WARNING, AUTH_STATUS_AR],
      },
      onClick: row => {
        dispatch(executeReport(row?.report_id));
      },
    },
    {
      icon: <i className="bx bx-download font-size-20 text-primary" />,
      text: "Download file đã import",
      isShow: !modalDetail,
      conditionVisible: {
        report_id: [],
      },
      onClick: row => {
        dispatch(
          downloadReportInvoice(
            row?.report_id,
            `LO_HOA_DON_${row?.code || ""}`
            //    +
            //   getTimeContent(row.parameters)
          )
        );
      },
    },
  ];

  const openReleaseModal = id => {
    setIdRelease(id);
    toggleConfirmReleaseModal();
  };

  const getAuthStatus = row => {
    let info = null;
    let infoError = null;
    if (row?.report?.status === AUTH_STATUS_REJECT) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do upload lỗi"
          className="font-size-20 bx bx-info-circle text-danger"
          onClick={() => {
            dispatch(getReportLog(row.report_id));
            setErrorUpload(row?.report?.log);
            toggleErrorUploadModal();
          }}
        ></i>
      );
    } else if (row?.report?.status === AUTH_STATUS_WARNING) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị cảnh báo"
          className="font-size-20 bx bx-error text-warning"
          onClick={() => {
            setErrorUpload(row?.report?.log);
            toggleErrorUploadModal();
          }}
        ></i>
      );
    } else {
      // info = (
      //   <div
      //     id={"message" + row.id}
      //     className="font-size-18 text-primary d-flex gap-1 align-items-center"
      //     style={{ cursor: "pointer" }}
      //   >
      //     <i
      //       //   style={{ cursor: "pointer" }}
      //       className="bx bx-info-circle text-primary"
      //     ></i>
      //     <UncontrolledTooltip
      //       placement="left"
      //       style={{
      //         textAlign: "left",
      //         fontSize: "15px",
      //         background: "white",
      //         color: "black",
      //         border: "1px solid blue",
      //         minWidth: "300px",
      //       }}
      //       target={"message" + row.id}
      //     >
      //       Tổng số hóa đơn: {row?.quantity?.total_quantity} <br />
      //       Đã phát hành: {row?.quantity?.approve_quantity} <br />
      //       Đã từ chối: {row?.quantity?.reject_quantity} <br />
      //       Chờ phát hành: {row?.quantity?.pending_quantity} <br />
      //     </UncontrolledTooltip>
      //   </div>
      // );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${
              commonStatus?.AUTH_STATUS[row.auth_status]?.badgeColor
            }`}
            pill
          >
            {commonStatus?.AUTH_STATUS[row.auth_status]?.text}
          </Badge>
          {info}
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Lỗi"",
    // [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // "Validate hoàn tất"",
    // [AUTH_STATUS_WARNING]: commonStatus?.AUTH_STATUS[AUTH_STATUS_WARNING]?.text, // "Cảnh báo"",
  };

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "code",
      text: "Mã lô",
      sort: true,
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectFilterAuthStatus,
      }),
    },
    {
      dataField: "type",
      text: "Loại hóa đơn",
      hidden: false,
      formatter: (cellContent, row) => SELECT_FILTER_TYPE[cellContent],
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: SELECT_FILTER_TYPE,
      }),
    },
    // {
    //   dataField: "khhdon",
    //   text: "Kí hiệu hóa đơn",
    //   sort: true,
    //   //   filter: textFilter({
    //   //     placeholder: t("placeholder.enter"),
    //   //   }),
    //   formatter: (cellContent, row) => {
    //     if (row.khmhdon || row.khhdon) {
    //       return row.khmhdon + row.khhdon;
    //     }
    //     return "";
    //   },
    // },
    // {
    //   dataField: "dvtte",
    //   text: "Đợn vị tiền tệ",
    //   hidden: false,
    // },
    // {
    //   dataField: "htttoan",
    //   text: "Hình thức thanh toán",
    //   hidden: false,
    // },
    {
      dataField: "checker_date",
      text: "Ngày cập nhật",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getInvoiceCampaignList(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getInvoiceCampaignList(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleInvoiceCampaignList(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getInvoiceCampaignList(params));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách lô hóa đơn</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách lô hóa đơn" + ` (${totalCount})`}
          />
          <UploadFileAttack
            isOpen={modalUploadFile}
            toggle={toggleUploadFileModal}
          />
          <DetailData
            isOpenModal={modalDetail}
            openReleaseModal={openReleaseModal}
            t={t}
            dataDetail={dataDetail}
            toggleModal={toggleViewDetailModal}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <ErrorUploadModal
                      isOpen={modalErrorUpload}
                      error={errorUpload}
                      toggle={toggleErrorUploadModal}
                    ></ErrorUploadModal>
                    {/* Deny modal */}
                    <ConfirmModal
                      isOpen={modalConfirmRelease}
                      titleHeader={"Xác nhận phát hành lô hóa đơn"}
                      titleBody={
                        "Hệ thống sẽ thực hiện gửi phát hành lô hóa đơn này"
                      }
                      isDisableButton={releaseCampaignsInvoiceData.loading}
                      onConfirm={note => {
                        dispatch(releaseCampaignsInvoice(idRelease));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmReleaseModal}
                    />
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          toggleUploadFileModal();
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Upload hóa đơn theo lô
                      </Button>
                      <ButtonDropdown
                        className="me-2"
                        isOpen={isOpenDownloadTemplate}
                        toggle={toggleOpenDownloadTemplate}
                      >
                        <DropdownToggle
                          className="btn-label"
                          caret
                          color="info"
                          outline
                        >
                          <i className="bx bx-download label-icon" />
                          Tải template
                          <i
                            style={{ marginLeft: "5px" }}
                            className="mdi mdi-chevron-down"
                          />
                        </DropdownToggle>
                        <DropdownMenu
                          style={{ zIndex: 3, border: " 1px solid #808080d4" }}
                        >
                          <Link
                            to={`/file/${TEMPLATE_UPLOAD_CAMPAIGN}`}
                            target="_blank"
                            download
                            style={{ color: "white" }}
                          >
                            <DropdownItem
                              style={{ position: "relative" }}
                              className="d-flex gap-1 align-items-center"
                            >
                              <i
                                style={{ color: "green" }}
                                className="far fa-file-archive"
                              />{" "}
                              <span className="text-primary">
                                {TEMPLATE_UPLOAD_CAMPAIGN}
                              </span>
                            </DropdownItem>{" "}
                          </Link>
                        </DropdownMenu>
                      </ButtonDropdown>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
